import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-shared-id',
  templateUrl: './shared-id.component.html',
  styleUrls: ['./shared-id.component.scss'],
})
export class SharedIdComponent {
  @Input() content?: string;
  @Input() content_class: string = 'sp-color__primary';
  @Input() is_shrinked_id?: boolean;
  @Output() content_click: EventEmitter<void> = new EventEmitter<void>();

  constructor(private utils_service: UtilsService) {}

  onCopyClick(): void {
    this.utils_service.copyClick(this.content);
  }

  getShrinkedID(): string {
    return this.utils_service.getShrinkedID(this.content);
  }
}
